import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getGuestbook = (landmark) =>
  api.get("/guestbook", { params: landmark ? { landmark } : {} }).then((r) => r.data);
export const addGuestbookNote = (payload) =>
  api.post("/guestbook", payload).then((r) => r.data);
export const deleteGuestbookNote = (id) =>
  api.delete(`/guestbook/${id}`).then((r) => r.data);

export const getBookmarks = () => api.get("/bookmarks").then((r) => r.data);
export const addBookmark = (payload) =>
  api.post("/bookmarks", payload).then((r) => r.data);
export const deleteBookmark = (id) =>
  api.delete(`/bookmarks/${id}`).then((r) => r.data);

export const getWeather = (lat, lon) =>
  api.get("/weather", { params: { lat, lon } }).then((r) => r.data);
